import React, { useState } from 'react'
import { Header, BrandIcon , Button } from '@ds.e/react'
import { useNavigate } from 'react-router-dom'
import BrandLogo from 'assets/icons/BrandLogo'
import { useAppContext } from '@hooks/useAppContext'
import { useDisplayHeader } from '@hooks/useDisplayHeader'
import LocalStorage from '@storage/browser/LocalStorage'

import { PATHS } from '@constants/paths'
import { IoMdPower } from "react-icons/io";
import { useSession } from '@services/useSession'

import '@ds.e/scss/lib/Box.css'
import '@ds.e/scss/lib/Header.css'
import '@ds.e/scss/lib/HeaderMenu.css'
import '@ds.e/scss/lib/BrandIcon.css'
import { usePostKillSession } from '@services/usePaymentsRecurrent'

const DeviceMarginTopMapping: {
    phone: number
    tablet: number
    laptop: number
    desktop: number
} = {
    phone: 40,
    tablet: 0,
    laptop: 70,
    desktop: 70,
}

export type HeaderWrapperTypes = {
    showMenu: boolean
    setMenuOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const HeaderWrapper = ({ showMenu, setMenuOpen }: HeaderWrapperTypes) => {
    const navigate = useNavigate()
    const storage = new LocalStorage()
    const { logOut } = useSession()

    const {
        appState,
        appState: { viewportSize },
    } = useAppContext()
    const { mutateAsync: mutatePostKillSession } = usePostKillSession()

    // const handleRedirectOnClick = () => navigate('/home')
    const handleRedirectOnClick = () => navigate(PATHS.HOME)
    // window.location.replace(window.location.origin)

    const [logOutOn, setLogOutOn] = useState(false);
    const logOutProcess = async () => {
        setLogOutOn( true )

        const params = {
            token: appState.session.accessToken
        }

        try {
            const restData = await mutatePostKillSession( { appState , params } )
            logOut()
        } catch (err: unknown) {
            logOut()
        }

        
    }

    const Logo = (
        <BrandIcon
            logo={<BrandLogo />}
            handleRedirectOnClick={handleRedirectOnClick}
            ariaLabel="Icon"
        />
    )

    const btnLogOut = (
        <Button buttonType="fill" className="dp-btnPositive btnLogout" onClick={ logOutProcess } showIconLeftLabel iconLeftLabel={<IoMdPower />} size="small"  />
    )

    return useDisplayHeader() ? (
        <>
            <Header
                device={appState.viewportSize}
                leftSection={{
                    sizes: {
                        phone: <></> ,
                        tablet: <></> ,
                        laptop: Logo,
                        desktop: Logo,
                    },
                }}
                middleSection={{
                    sizes: {
                        phone: Logo ,
                        tablet: Logo ,
                        laptop: <></>,
                        desktop: <></>,
                    },
                }}
                rightSection={{
                    sizes: {
                        phone: btnLogOut ,
                        tablet: btnLogOut ,
                        laptop: btnLogOut ,
                        desktop: btnLogOut ,
                    },
                }}
                
            />

            {
                logOutOn &&
                <div className="logoutMessage">
                    <p>Adiós, vuelve pronto...</p>
                </div>
            }
        </>
    ) : null
}

export default HeaderWrapper
